export const FINWISE = 'FinWise';
export const FEB = 'First Electronic';
export const CORE = 'Core';
export const CCB = 'Capital Community Bank';

export const SITE_HEADER_HEIGHT = '4.3125rem';
export const LEFT_COLUMN_WIDTH = '48rem';
export const COLUMN_GAP = '2rem';
export const RIGHT_COLUMN_WIDTH = '24rem';
export const SIDE_NAV_WIDTH = '12rem';

export const DEBT_MANAGEMENT_COMPANY = 'Debt Management Company';

export const COLLECTION_PHONE_MAPPING = {
  January: '(866) 300-1169',
  'Markoff Law': '(312) 698-7300',
  'Miller & Steeno': '(312) 698-7300',
  'MLG Collections (Migdal)': '(312) 726-9090',
  'True Accord': '(866) 611-2731',
  'Debt Management Company': '(855) 408-5000'
};

export const NEW_CARD = 'oppfi_new_card';

export const WRITTEN_OFF = 'WRITTEN OFF';
export const PAST_DUE = 'PAST DUE';
